import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import SalonPromoController from '@club/customer/api/SalonPromoController'
import useAsyncEffect from '@hooks/useAsyncEffect'
import useAuth from '@hooks/useAuth'
import useUpdateEffect from '@hooks/useUpdateEffect'
import { ReactComponent as CheckIcon } from '@icons/check.svg'
import { ReactComponent as CloseIcon } from '@icons/close.svg'
import { ReactComponent as DiscountIcon } from '@icons/discount.svg'
import { debounce } from 'lodash'
import React, { useState } from 'react'

export default function PaymentPromo({ salon, onChange }: Props) {
    const auth = useAuth<Resources.Customer>()
    const [promo, setPromo] = useState<Customer.States.Promo>()
    const club = auth.user.club || auth.user.membership?.club

    useAsyncEffect(async () => {
        if (!club) return
            
        try {
            const promo = await SalonPromoController.show(club.id, salon.state.id)
            const discount = promo?.discount
    
            if (discount) {
                setPromo({
                    fee: Math.round(salon.state.fee * (100 - discount)) / 100,
                    discount,
                    found: true,
                    icon: <CheckIcon />,
                    comment: `You're a member of the group. It gives you a ${discount}% discount! You may proceed to the payment.`,
                    club: true
                })
            }
        } catch (e) {
            console.log(e)
         }
    }, [])

    useUpdateEffect(() => onChange(promo), [promo])

    const handlePromoChange = debounce(async (code: string) => {
        try {
            const discount = await salon.api.payment.discount(code).request()
            setPromo({
                fee: Math.round(salon.state.fee * (100 - discount)) / 100,
                discount,
                code,
                found: true,
                icon: <CheckIcon />,
                comment: `You have a valid promo code. It gives you a ${discount}% discount! You may proceed to the payment.`
            })
        } catch {
            if (code) {
                setPromo({
                    code,
                    icon: <CloseIcon />,
                    comment: "We can't find this promo code."
                })
            } else {
                setPromo(undefined)
            }
        }
    }, 800)

    if (promo?.club) {
        return (
            <Grid gap="10px">
                <b>Promo Code</b>
                <p>You're the member of {club!.name}. It gives you the discount of {promo.discount}%.</p>
            </Grid>
        )
    }

    return (
        <Grid gap="10px">
            <b>Promo Code</b>
            <Grid gap="5px">
                <Input id="code" name="code" placeholder="Type a valid promo code" onChange={(e) => handlePromoChange(e.target.value)} icon={promo?.icon || <DiscountIcon />} />
                {promo?.comment && <small>{promo?.comment}</small>}
            </Grid>
        </Grid>
    )
}

interface Props {
    salon: Customer.Models.Salon.Stateful
    onChange: (promo: Customer.States.Promo | undefined) => void
}